export const changeWebPageTitleService = (
    isSkinSmart: boolean,
    webPageName: string
) => {
    const webPageTitle = webPageName + ' | Internal Tools';

    const faviconRoute = isSkinSmart
        ? '/assets/images/SmartAccess_Ico.ico'
        : '/assets/images/favicon-siesa.ico';

    document.title = webPageTitle;
    document.getElementById('favicon')?.setAttribute('href', faviconRoute);

    return {
        webPage: webPageTitle,
    };
};
